
const urlParam = new URL(window.location.href);

export function getSiteIdentifier() {

	if(urlParam.searchParams.get("siteIdentifier")){
		return urlParam.searchParams.get("siteIdentifier");
	} else {
		throw "Site Identifier  is missing";
	}
}

export function getFloorIdentifier() {
	if(urlParam.searchParams.get("floorIdentifier")){
		return urlParam.searchParams.get("floorIdentifier");
	} else {
		throw "Floor Identifier  is missing";
	}
}
